export default "__VITE_ASSET__BbcJEVgo__"